import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
    .overflow--hidden {
        overflow: hidden !important;
    }

    html[data-whatinput='mouse']  {
        *:focus, *:focus-within {
            outline: none;
        }
    }

    .grid-page-layout {
        box-sizing: border-box;
    }

    #react-container {
        color: ${props => props.theme.functionColor?.function100};
        background-color: ${props => props.theme.functionColor?.function0};
    }
`;
